import request from '@/utils/request'

const url1 = 'elevatorCollect'
/** 获取电梯列表 */
export function searchElevatorCollectList(data) {
  return request({
    url: `${url1}/searchElevatorCollectList`,
    method: 'post',
    data
  })
}

/** 判断是否收藏电梯 */
export function searchUserCollectElevatorInfo(data) {
  return request({
    url: `${url1}/searchUserCollectElevatorInfo`,
    method: 'post',
    data
  })
}

/** 收藏电梯 */
export function insertUserCollectElevatorInfo(data) {
  return request({
    url: `${url1}/insertUserCollectElevatorInfo`,
    method: 'post',
    data
  })
}

/** 取消收藏 */
export function deleteUserCollectElevatorInfo(data) {
  return request({
    url: `${url1}/deleteUserCollectElevatorInfo`,
    method: 'post',
    data
  })
}
